import React from 'react';
import { format, isToday } from 'date-fns';
import { getStatusStyle } from './calendarUtils';

// Time-grid Day view with vertical 24-hour layout.
export function CalendarDayView({ date, filteredShifts, onShiftClick }) {
  const dk = format(date, 'yyyy-MM-dd');
  const dayShifts = filteredShifts.filter(s => s.date === dk).sort((a, b) => (a.start_time || '').localeCompare(b.start_time || ''));
  const hours = Array.from({ length: 24 }, (_, i) => i);

  return (
    <div className="relative">
      <div className="sticky top-0 z-20 bg-white border-b px-4 py-2 text-center">
        <p className={`text-lg font-bold ${isToday(date) ? 'text-blue-700' : ''}`}>{format(date, 'EEEE, d MMMM yyyy')}</p>
      </div>
      <div className="relative">
        {hours.map(h => (
          <div key={h} className="flex border-b" style={{ minHeight: 48 }}>
            <div className="w-16 flex-shrink-0 text-right pr-2 py-1 text-[10px] text-muted-foreground border-r">{String(h).padStart(2, '0')}:00</div>
            <div className="flex-1 relative" />
          </div>
        ))}
        {/* Shift blocks overlay */}
        <div className="absolute top-0 left-16 right-0">
          {dayShifts.map(shift => {
            const [sh, sm] = (shift.start_time || '0:0').split(':').map(Number);
            const [eh, em] = (shift.end_time || '0:0').split(':').map(Number);
            const top = (sh + sm / 60) * 48;
            const height = Math.max(24, ((eh + em / 60) - (sh + sm / 60)) * 48);
            const style = getStatusStyle(shift.status);
            return (
              <div key={shift.id} className={`absolute left-1 right-1 rounded-md border px-2 py-1 cursor-pointer hover:shadow-md ${style.bg}`}
                style={{ top, height, zIndex: 5 }} onClick={() => onShiftClick(shift)} data-testid={`day-shift-${shift.id}`}>
                <p className={`text-[11px] font-semibold ${style.text}`}>{shift.start_time}–{shift.end_time}</p>
                <p className="text-[10px] font-medium truncate">{shift.participant_name}</p>
                <p className="text-[9px] truncate text-slate-500">{shift.assigned_staff?.map(s => s.name).join(', ') || 'Open'}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
